<div class="global-nav">
    <!--Header Section 2-->
    <div class="section-two">
        <div class="nav-container">
            <div class="section-two__nav-left">
                <ul class="inline-ul text-upper">
                    <!--My Plan Manager-->
                    <li class="" *ngIf='allLabelsForGlobalTopNav'>
                        <nav class="navbar" aria-label="top header">
                            <div class="dropdown section-two__nav-left-dropdown">
                                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton"
                                    (click)="planManagerDropdownClick= !planManagerDropdownClick" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    {{allLabelsForGlobalTopNav['menu-links'][7].title}}
                                    <mat-icon class="expand_less">expand_less</mat-icon>
                                    <mat-icon class="expand_more">expand_more</mat-icon>
                                </button>

                                <div class="dropdown-menu dropdown-menu-align" role="menu" 
                                    aria-labelledby="dropdownMenuButton">
                                    <a role="menuitem" class="dropdown-item dropdown-style"
                                        href="https://investor.vanguard.com/corporate-portal/"
                                        target="_blank">{{allLabelsForGlobalTopNav['menu-links'][9].title}}</a>
                                    <a role="menuitem" class="dropdown-item dropdown-style"
                                        href="https://institutional.vanguard.com/web/c1/inst-investor-home/"
                                        target="_blank">{{allLabelsForGlobalTopNav['menu-links'][10].title}}</a>
                                </div>
                            </div>
                        </nav>
                    </li>
                    <!--End of My Plan Manager-->
                </ul>
            </div>
        </div>
    </div>
    <!--End of Header Section 2-->

    <!--Header Section 3-->
    <div class="section-three">
        <!--For Desktop-->
        <div class="full-width">
            <div class="nav-container justify-normal position-relative m-0">
                <div class="container-fluid">
                    <!--Logo-->
                    <div class="logo-container">
                        <!-- <img class="logo" aria-label="Vanguard Home" alt="Vanguard Home" src="/dcrkpublic/assets/vanguard-logo.svg" /> -->
                        <img class="logo" aria-label="Vanguard Home" alt="Vanguard Home" src = "{{env ? serverPath : localPath}}"  />
                    </div>
                    <!--End of Logo-->
                </div>
            </div>
        </div>
        <!--End of For Desktop-->
    </div>
    <!--End of Header Section 3-->
</div>
<!-- <app-inactivity-timer *ngIf="!isInternalUser"></app-inactivity-timer>
<app-log-message-layer></app-log-message-layer> -->
